import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { DeliveryNoteEndpoint } from '../../constants/delivery-note-endpoint';
import { LatestNotification } from '../../../monitoring/models';
import { DeliveryNoteParams } from '../../models';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteNotificationsService {
  constructor(private http: WrapperHttpService) {}

  getNotifications({ deliveryNoteNumber, sapId }: DeliveryNoteParams): Observable<LatestNotification[]> {
    const params = sapId ? `?${getQueryStringFromObject({ sapId })}` : '';

    return this.http
      .withLoading()
      .get<LatestNotification[]>(
        `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.Notifications}${params}`,
      );
  }
}
